import google from 'app/lib/google';
import { Event, PromoCodeWithCharges } from 'app/shared/typings';

interface Params {
  orderId: number;
  event: Event;
  numberOfTickets: number;
  finalPrice: number;
  fee: number;
  promoCodeWithCharges?: PromoCodeWithCharges;
}

export function trackSuccessfulOrder({
  orderId,
  event,
  numberOfTickets,
  finalPrice,
  promoCodeWithCharges,
  fee,
}: Params) {
  if (!event) {
    return;
  }

  const totalPriceBeforeDiscount = (event.price + fee) * numberOfTickets;
  const discountAmount = totalPriceBeforeDiscount - finalPrice;

  google.dataLayer({
    event: 'successful_order',
    order: {
      id: orderId,
      currency: event.city.currencyCode
        ? event.city.currencyCode.toUpperCase()
        : '',
      totalPrice: finalPrice,
      totalPriceBeforeDiscount,
      promo: {},
    },
  });

  if (promoCodeWithCharges && promoCodeWithCharges.promoCode) {
    google.dataLayer({
      order: {
        promo: {
          code:
            promoCodeWithCharges.promoCode.code &&
            promoCodeWithCharges.promoCode.code.toUpperCase(),
          discountAmount: totalPriceBeforeDiscount - finalPrice,
          // Note this is purely for our partner Unidays. The requirements
          // from Unidays on what this needs to contain are unclear. In the
          // old checkout flow this was only populated if the promo code was
          // specifically a "percentage discount" type promo code. If it was any
          // other type of promo code this would not have been set. Currently
          // the "percentage discount" values are not returned by the server
          // so just manually calculating this instead, which should be the same.
          // Lastly, unidays came back and said this field was not important
          // so just leaving logic as is.
          percentageDiscount: (discountAmount / totalPriceBeforeDiscount) * 100,
        },
      },
    });

    if (
      promoCodeWithCharges.promoCode.code.toUpperCase().startsWith('UNIDAY')
    ) {
      google.dataLayer({
        event: 'unidays_successful_order',
      });
    }
  }
}
